import * as React from "react";
const AddIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      {...props}
    >
      <path
        fill="#044E97"
        fillRule="evenodd"
        d="M10.001 2.291c.576 0 1.042.466 1.042 1.042v5.625h5.625a1.042 1.042 0 0 1 0 2.083h-5.625v5.625a1.042 1.042 0 0 1-2.083 0v-5.625H3.335a1.042 1.042 0 0 1 0-2.083H8.96V3.333c0-.576.466-1.042 1.041-1.042Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default AddIcon;
